(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.rootDoc = document.documentElement;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.nouveauHero = document.querySelector('.nouveau-hero');
      this.nouveauHeroMql = window.matchMedia('(max-width: 1000px)');
      this.nouveauHeroLock = false;
      this.updateNouveauHeroLockHandler = this.updateNouveauHeroLock.bind(this);

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.updateNouveauHeroLock();
      window.addEventListener('resize', this.updateNouveauHeroLockHandler, { passive: true });
      if (typeof this.nouveauHeroMql.addEventListener === 'function') {
        this.nouveauHeroMql.addEventListener('change', this.updateNouveauHeroLockHandler);
      } else if (typeof this.nouveauHeroMql.addListener === 'function') {
        this.nouveauHeroMql.addListener(this.updateNouveauHeroLockHandler);
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.updateNouveauHeroLockHandler);
      if (this.nouveauHeroMql) {
        if (typeof this.nouveauHeroMql.removeEventListener === 'function') {
          this.nouveauHeroMql.removeEventListener('change', this.updateNouveauHeroLockHandler);
        } else if (typeof this.nouveauHeroMql.removeListener === 'function') {
          this.nouveauHeroMql.removeListener(this.updateNouveauHeroLockHandler);
        }
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    clamp(value, min, max) {
      return Math.min(max, Math.max(min, value));
    }

    getNouveauHeroLockDuration() {
      if (!this.nouveauHero) return 0;
      const raw = window.getComputedStyle(this.nouveauHero).getPropertyValue('--nouveau-hero-mobile-lock').trim();
      if (raw.endsWith('px')) {
        const value = parseFloat(raw);
        if (Number.isFinite(value) && value > 0) return value;
      }
      return this.clamp(window.innerHeight * 0.4, 220, 520);
    }

    getNouveauHeroHeight(rect) {
      let minHeight = 0;
      const inlineMinHeight = this.nouveauHero.style.minHeight;
      if (inlineMinHeight && inlineMinHeight.endsWith('px')) {
        minHeight = parseFloat(inlineMinHeight) || 0;
      }
      if (!minHeight) {
        const computed = window.getComputedStyle(this.nouveauHero);
        if (computed.minHeight.endsWith('px')) {
          minHeight = parseFloat(computed.minHeight) || 0;
        } else if (computed.minHeight.endsWith('vh') || computed.minHeight.endsWith('svh')) {
          const vhValue = parseFloat(computed.minHeight) || 0;
          minHeight = (vhValue / 100) * window.innerHeight;
        }
      }
      const baseHeight = Math.max(
        rect.height,
        this.nouveauHero.offsetHeight,
        this.nouveauHero.scrollHeight,
        minHeight,
        window.innerHeight
      );
      const lockDuration = this.getNouveauHeroLockDuration();
      return Math.max(baseHeight, window.innerHeight + lockDuration);
    }

    shouldLockForNouveauHero(scrollTop) {
      this.nouveauHero = this.nouveauHero || document.querySelector('.nouveau-hero');
      if (!this.nouveauHero || !this.nouveauHeroMql.matches) return false;
      const rect = this.nouveauHero.getBoundingClientRect();
      const heroHeight = this.getNouveauHeroHeight(rect);
      const heroTop = rect.top + scrollTop;
      const heroBottom = heroTop + heroHeight;
      return scrollTop < heroBottom;
    }

    updateNouveauHeroLock(scrollTop) {
      const resolvedScrollTop = Number.isFinite(scrollTop)
        ? scrollTop
        : window.pageYOffset || document.documentElement.scrollTop;
      const shouldLock = this.shouldLockForNouveauHero(resolvedScrollTop) ||
        (this.nouveauHeroMql.matches && document.documentElement.classList.contains('nouveau-hero--lock-header'));
      this.nouveauHeroLock = shouldLock;
      if (this.rootDoc) {
        this.rootDoc.classList.toggle('nouveau-hero--lock-header', shouldLock);
      }
      if (shouldLock) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');
      }
      return shouldLock;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      const lockForHero = this.updateNouveauHeroLock(scrollTop);
      if (lockForHero) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.nouveauHeroLock || this.shouldLockForNouveauHero(scrollTop)) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (this.nouveauHeroLock) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (this.nouveauHeroLock) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
